import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { getTranslate } from 'react-localize-redux';
import {
    Button, Typography, CircularProgress, TextField,
} from '@material-ui/core';
import * as AuthStore from '../../../app/store/AuthStore';
import urls from '../../../app/urls';

const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        marginBottom: theme.spacing(3),
    },
    loginDescription: {
        marginBottom: theme.spacing(2),
    },
    textField: {
        marginBottom: theme.spacing(2),
    },
    actionButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: theme.spacing(3),
    },
    subActions: {
    },
    infoContainer: {
        marginTop: theme.spacing(3),
    },
    loading: {
        height: 200,
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    completedMessageContainer: {
        marginTop: theme.spacing(2),
        background: theme.palette.grey[50],
        color: theme.colors.blue,
        padding: theme.spacing(2),
        borderRadius: theme.spacing(0.5),
        border: theme.borders.dim,
    },
    homeLink: {
        marginTop: theme.spacing(2),
    },
});

const ResetPassword = ({
    match, translate, loading, resetPassword, errorMessage, classes,
}) => {
    const [{ password, submitted }, setState] = useState({
        password: '',
        submitted: false,
    });

    const handleResetPassword = (e) => {
        e.preventDefault();
        if (!loading) {
            resetPassword({
                newPassword: password,
                token: match.params.token,
            }, {
                callback: () => {
                    setState({
                        submitted: true,
                    });
                },
            });
        }
    };

    const completed = submitted && !loading && !errorMessage;

    return (
        <form onSubmit={handleResetPassword} className={classes.root}>
            <div className={classes.header}>
                <Typography variant="h6">
                    {translate('login.forgotPassword')}
                </Typography>
            </div>
            {loading ? (
                <div className={classes.loading}>
                    <CircularProgress />
                </div>
            ) : (
                <div>
                    {completed ? (
                        <>
                            <div className={classes.completedMessageContainer}>
                                <Typography variant="body2" color="inherit">
                                    {translate('login.resetPasswordSubmitted')}
                                </Typography>
                            </div>
                            <Link to={urls.login}>
                                <Typography variant="button" className={classes.homeLink} align="center">
                                    {translate('login.backToFrontPage')}
                                </Typography>
                            </Link>
                        </>
                    ) : (
                        <>
                            <Typography color="textSecondary" className={classes.loginDescription}>
                                {translate('login.resetPasswordDescription')}
                            </Typography>

                            <TextField
                                id="password"
                                type="password"
                                label={translate('login.password')}
                                className={classes.textField}
                                value={password}
                                onChange={e => setState({ password: e.target.value })}
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />

                            <div className={classes.actionButtons}>
                                <Link to={urls.login}>
                                    <Typography variant="button" align="center">
                                        {translate('login.cancel')}
                                    </Typography>
                                </Link>
                                <Button className={classes.sendButton} onClick={handleResetPassword} variant="contained" color="primary" disabled={loading}>
                                    {translate('login.send')}
                                </Button>
                            </div>

                        </>
                    )}
                    <div className={classes.infoContainer}>
                        {errorMessage && (
                            <Typography color="error" align="center">
                                {translate(`errors.${errorMessage}`, null, { onMissingTranslation: () => translate('login.resetPasswordError') })}
                            </Typography>
                        )}
                    </div>
                </div>
            )}
        </form>
    );
};

ResetPassword.propTypes = {
    classes: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    resetPassword: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
};

ResetPassword.defaultProps = {
    errorMessage: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    loading: state.auth.loading,
    errorMessage: [].concat(state.auth.errors).filter(val => val).join('<br/>'),
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(AuthStore.actionCreators, dispatch),
});

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withStyles(styles)(ResetPassword)),
);
